var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntenIndicator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A3244C",
    d: "M.415 15.407A2.59 2.59 0 0 1 3 12.814a2.59 2.59 0 0 1 2.585 2.593A2.59 2.59 0 0 1 3 18a2.59 2.59 0 0 1-2.585-2.593"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C92659",
    d: "M.415 9.356A2.59 2.59 0 0 1 3 6.763a2.59 2.59 0 0 1 2.585 2.593A2.59 2.59 0 0 1 3 11.949 2.59 2.59 0 0 1 .415 9.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F02867",
    d: "M.415 3.305A2.59 2.59 0 0 1 3 .712a2.59 2.59 0 0 1 2.585 2.593A2.59 2.59 0 0 1 3 5.898 2.59 2.59 0 0 1 .415 3.305"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntenIndicator);
export default __webpack_public_path__ + "static/media/anten-indicator.45076f58bf1f194dc1bf6f5a1c3024f6.svg";
export { ForwardRef as ReactComponent };